@if (data) {
  <fui-rows [label]="'Venue Address'">
    <fui-content-layout-header-control slot="after">
      @if (!editing && model.canEdit(true)) {
        <fui-link-button [title]="'edit'"
        (click)="edit()"></fui-link-button>
      }
    </fui-content-layout-header-control>
    @if (data && formGroupAddress) {
      <fui-row [formGroup]="formGroupAddress">
        <fui-two-columns>
          <fui-column>
            <fui-text-control
              formControlName="addressStreet"
              [control]="formGroupAddress.get('addressStreet')"
              [label]="'fhm.company.addressStreet'"
              [placeholder]="'fhm.common.label.no-label'"
              [disabled]="!editing"
            [(ngModel)]="data.addressStreet"></fui-text-control>
          </fui-column>
          <fui-column>
            <fui-text-control
              formControlName="addressCity"
              [control]="formGroupAddress.get('addressCity')"
              [label]="'fhm.company.addressCity'"
              [placeholder]="'fhm.common.label.no-label'"
              [disabled]="!editing"
            [(ngModel)]="data.addressCity"></fui-text-control>
          </fui-column>
        </fui-two-columns>
      </fui-row>
      <fui-row [formGroup]="formGroupAddress">
        <fui-two-columns>
          <fui-column>
            <fui-tandem-field>
              <fhm-state-select-control
                [(value)]="data.addressState"
                [disabled]="!editing">
              </fhm-state-select-control>
              <fui-numeric-control
                [decimals]="0"
                formControlName="addressPostcode"
                [control]="formGroupAddress.get('addressPostcode')"
                [label]="'fhm.company.addressPostcode'"
                [placeholder]="'fhm.common.label.no-label'"
                [disabled]="!editing"
              [(ngModel)]="data.addressPostcode"></fui-numeric-control>
            </fui-tandem-field>
          </fui-column>
        </fui-two-columns>
      </fui-row>
      @if (editing && !model.draft) {
        <fui-row>
          <fhm-action-buttons>
            @if (!newEntity) {
              <fhm-remove-button [title]="'fhm.common.button.cancel'"
              (clicked)="cancelEdit()"></fhm-remove-button>
            }
            <fhm-provision-button [title]="!newEntity ? 'fhm.common.button.save' : 'fhm.common.button.create'"
            (clicked)="save()"></fhm-provision-button>
          </fhm-action-buttons>
        </fui-row>
      }
    }
  </fui-rows>
}


